<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog" style="width: 926px;">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="close()">
            <i class="icon-close"></i>
          </a>
          <h3 :key="`Already-Visit-h3-${record.id}`"  class="modal-title">要保人{{record.name| getMaskName}}已親晤拜訪回報</h3>
        </div>
        <div class="modal-body send-modal-body" style="min-height:220px;" :class="{ 'section-loading': isLoading }">
          <div class="form-group mt-3">
            <div>
              <span>Email</span>&nbsp;&nbsp;&nbsp;&nbsp;
              <div class="radio radio-inline">
                <input
                  v-if="record.mail_adj_item_code=='0'"
                  type="radio"
                  v-model="req.EmailPicked"
                  name="Email-Alr-1"
                  id="Email-Alr-1"
                  value="1"
                  :disabled="true"
                />
                <input
                  v-else
                  type="radio"
                  v-model="req.EmailPicked"
                  name="Email-Alr-1"
                  id="Email-Alr-1"
                  value="1"
                />
                <label for="Email-Alr-1">已變更</label>
              </div>
              <div class="radio radio-inline">
                <input
                  v-if="record.mail_adj_item_code=='0'"
                  type="radio"
                  v-model="req.EmailPicked"
                  name="Email-Alr-2"
                  id="Email-Alr-2"
                  value="2"
                  :disabled="true"
                />
                <input
                  v-else
                  type="radio"
                  v-model="req.EmailPicked"
                  name="Email-Alr-2"
                  id="Email-Alr-2"
                  value="2"
                />
                <label for="Email-Alr-2">保戶已知悉不變更</label>
              </div>
            </div>
            <div>
              <span>手機</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <div class="radio radio-inline">
                <input
                  v-if="record.mobl_adj_item_code=='0'"
                  type="radio"
                  v-model="req.MobilPicked"
                  name="mobil-Alr-1"
                  id="mobil-Alr-1"
                  value="1"
                  :disabled="true"
                />
                <input
                  v-else
                  type="radio"
                  v-model="req.MobilPicked"
                  name="mobil-Alr-1"
                  id="mobil-Alr-1"
                  value="1"
                />
                <label for="mobil-Alr-1">已變更</label>
              </div>
              <div class="radio radio-inline">
                <input
                  v-if="record.mobl_adj_item_code=='0'"
                  type="radio"
                  v-model="req.MobilPicked"
                  name="mobil-Alr-2"
                  id="mobil-Alr-2"
                  value="2"
                  :disabled="true"
                />
                <input
                  v-else
                  type="radio"
                  v-model="req.MobilPicked"
                  name="mobil-Alr-2"
                  id="mobil-Alr-2"
                  value="2"
                />
                <label for="mobil-Alr-2">保戶已知悉不變更</label>
              </div>
            </div>
            <div>
              <span>地址</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <div class="radio radio-inline">
                <input
                  v-if="record.addr_adj_item_code=='0'"
                  type="radio"
                  v-model="req.AddrPicked"
                  name="addr-Alr-1"
                  id="addr-Alr-1"
                  value="1"
                  :disabled="true"
                />
                <input
                  v-else
                  type="radio"
                  v-model="req.AddrPicked"
                  name="addr-Alr-1"
                  id="addr-Alr-1"
                  value="1"
                />
                <label for="addr-Alr-1">已變更</label>
              </div>
              <div class="radio radio-inline">
                <input
                  v-if="record.addr_adj_item_code=='0'"
                  type="radio"
                  v-model="req.AddrPicked"
                  name="addr-Alr-2"
                  id="addr-Alr-2"
                  value="2"
                  :disabled="true"
                />
                <input
                  v-else
                  type="radio"
                  v-model="req.AddrPicked"
                  name="addr-Alr-2"
                  id="addr-Alr-2"
                  value="2"
                />
                <label for="addr-Alr-2">保戶已知悉不變更</label>
              </div>
            </div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <div class="radio radio-inline">
              <input
                v-if="record.addr_adj_item_code=='0'"
                type="radio"
                v-model="req.AddrPicked"
                name="radio-Alr-7"
                id="radio-Alr-7"
                value="4"
                :disabled="true"
              />
              <input
                v-else
                type="radio"
                v-model="req.AddrPicked"
                name="radio-Alr-7"
                id="radio-Alr-7"
                value="4"
              />
              <label for="radio-Alr-7">地址為公司行號/營業場所(必填備註說明)</label>
            </div>
            <div>備註</div>
            <div>
              <input
                v-if="req.AddrPicked ||req.MobilPicked ||req.EmailPicked"
                type="text"
                id="Alrreason"
                name="Alrreason"
                maxlength="50"
                placeholder="地址為公司行號/營業場所請填寫公司行號名稱或其他備註內容"
                class="form-control"
                v-model="req.reason"
              />
              <input
                v-else
                type="text"
                id="Alrreason"
                name="Alrreason"
                maxlength="50"
                placeholder="地址為公司行號/營業場所請填寫公司行號名稱或其他備註內容"
                class="form-control"
                v-model="req.reason"
                :disabled="true"
              />
            </div>
            <br />
          </div>
          <div>
            <span>
              *已確認資料正確請備註：資料皆正確<br />
              *如為直系家戶關係請備註：家戶關係為XX<br />
              *客戶欲共用通訊資料請備註：已補聲明書或後補聲明書
            </span>
            <div class="action text-right">
              <a @click.stop.prevent="previous()" class="btn btn-primary">上一步</a>
              <a @click.stop.prevent="submit()" class="btn btn-primary">提交</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 沒有資訊-->
    <warning-modal
      :message="message"
      :open="warningModalOpen"
      :confirmText="'確定送出'"
      :cancelText="'上一步'"
      @submit="ClosewarningModal()"
      @close="panelClose('warningModalOpen')"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
import { updateVisit } from "@/service";
import WarningModal from "@/desktop/components/WarningModal";

export default {
  name: "AlreadyVisitModal",
  mixins: [commonMixin],
  components: { WarningModal },
  props: {
    record: {
      // 客戶list 資料
      type: Object,
      default: () => {
        return null;
      }
    },
    open: {
      type: Boolean,
      default: false
    },
    catInfo: {
      // 專區資訊
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      dtData: [],
      checkAll: false,
      warningModalOpen: false,
      message: "",
      nameBir: "",
      req: {
        reason: "",
        EmailPicked: "",
        MobilPicked: "",
        AddrPicked: ""
      },
      edit: false,
      isLoading: false,
    };
  },
  watch: {
    open(val) {
      if (val) {
        this.Init();
      }
    }
  },
  methods: {
    ...mapActions(["setPageLock"]),
    Init() {
      // 初始化
      this.req.EmailPicked = this.record.visit_Reply_email;
      this.req.MobilPicked = this.record.visit_Reply_mobl;
      this.req.AddrPicked = this.record.visit_Reply_addr;
      this.req.reason = this.record.visit_memo;
      this.registerHanlink(); // for 難字更新
    },
    submit() {
      if ((this.record.mail_adj_item_code != "0") & !this.req.EmailPicked) {
        this.setToastMsg("尚有回報項目未點選，請再確認後再「提交」");
      } else if (
        (this.record.mobl_adj_item_code != "0") &
        !this.req.MobilPicked
      ) {
        this.setToastMsg("尚有回報項目未點選，請再確認後再「提交」");
      } else if (
        (this.record.addr_adj_item_code != "0") &
        !this.req.AddrPicked
      ) {
        this.setToastMsg("尚有回報項目未點選，請再確認後再「提交」");
      } else if ((this.req.AddrPicked == "4") & !this.req.reason) {
        this.setToastMsg("如客戶欲約定地址為公司行號/營業場所請填寫公司行號名稱或其他備註內容，以避免後續糾紛！");
      } else if ((this.req.EmailPicked == "2" || this.req.MobilPicked == "2" ||this.req.AddrPicked == "2" ) & !this.req.reason) {
        this.setToastMsg("如已確認客戶資料不變更，請填寫備註，以避免後續糾紛！");
      } else {
        this.message =
          "<span style=color:red;>請確認本次回報已確實填寫再點選送出！</span><br/>";
        this.panelOpen("warningModalOpen");
      }
    },
    ClosewarningModal() {
      this.panelClose("warningModalOpen");
      let reportData = {
        EmailPicked: this.req.EmailPicked,
        MobilPicked: this.req.MobilPicked,
        AddrPicked: this.req.AddrPicked,
        reasonmemo: this.req.reason,
        customer_id: this.record.id
      };
      this.isLoading = true; //開啟遮罩
      updateVisit(
        this.$store.state.userInfo.id,
        this.$store.state.userInfo.divNo,
        reportData
      ).then(result => {
        this.isLoading = false; //關閉遮罩
        if (result.header && result.header.status == "200") {
          this.close();
        } else {
          this.close();
        }
      });
    },
    close() {
      this.$emit("close");
    },
    previous() {
      this.req.EmailPicked = "";
      this.req.MobilPicked = "";
      this.req.AddrPicked = "";
      this.req.reason = "";
      this.$emit("previous");
    }
  },
  mounted() {}
};
</script>

<style>
.vdp-datepicker input {
  width: 100px;
  padding: 10px;
}
.select-100 {
  width: 170px;
}
.non-select-arrow {
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: "";
}
.btn-grids .btn {
  position: relative;
  padding: 8px;
  width: 24%;
  font-size: 1rem;
  margin: 0px;
  margin-bottom: 10px;
  margin-right: 1%;
}
.btn-grids .add-new {
  padding: 8px;
  width: 50px !important;
  font-size: 16px;
}
.btn-grids .btn .close {
  position: absolute;
  right: -10px;
  top: -10px;
}
</style>